import React from 'react'
import './style.css'

const SubscriptionTable = () => {
    return (
        <>
            <div className="subscription-table-main-box">
                <div className="container p-0">
                    <div className="row">
                        <div className="col-md-12">
                            <h3><strong>Subscription Comparison Table:</strong></h3>
                            <p>The ISIT platform offers distinct pricing and features for each role. Below are the details for each role's subscription packages:</p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="subscription-table-container">
                                <div className="table-responsive">
                                    <table className="table subscription-table">
                                        <thead className="subscription-table-head">
                                            <tr>
                                                <th scope="col" className="subscription-table-header-text">Features</th>
                                                <th scope="col" className="subscription-table-header-text">Free Trial</th>
                                                <th scope="col" className="subscription-table-header-text">30-Day Subscription</th>
                                                <th scope="col" className="subscription-table-header-text">365-Day Subscription (Annual Plan)</th>
                                            </tr>
                                        </thead>
                                        <tbody className="subscription-table-body">
                                            <tr>
                                                <td className="subscription-table-row-label">Price</td>
                                                <td>Free</td>
                                                <td>$9.99 / month</td>
                                                <td>$99.99 / year</td>
                                            </tr>
                                            <tr>
                                                <td className="subscription-table-row-label">Premium Access</td>
                                                <td>Limited</td>
                                                <td><i className="fa-solid fa-check checkbox-subscription-table"></i> Full Access</td>
                                                <td><i className="fa-solid fa-check checkbox-subscription-table"></i> Full Access</td>
                                            </tr>
                                            <tr>
                                                <td className="subscription-table-row-label">Data Sync & Backup</td>
                                                <td>❌</td>
                                                <td><i className="fa-solid fa-check checkbox-subscription-table"></i></td>
                                                <td><i className="fa-solid fa-check checkbox-subscription-table"></i></td>
                                            </tr>
                                            <tr>
                                                <td className="subscription-table-row-label">Priority Support</td>
                                                <td>❌</td>
                                                <td><i className="fa-solid fa-check checkbox-subscription-table"></i> Email</td>
                                                <td><i className="fa-solid fa-check checkbox-subscription-table"></i> Email + Technical</td>
                                            </tr>
                                            <tr>
                                                <td className="subscription-table-row-label">Early Feature Access</td>
                                                <td>❌</td>
                                                <td>❌</td>
                                                <td><i className="fa-solid fa-check checkbox-subscription-table"></i></td>
                                            </tr>
                                            <tr>
                                                <td className="subscription-table-row-label">Billing Flexibility</td>
                                                <td>N/A</td>
                                                <td>Monthly</td>
                                                <td>Annual (Save ~20%)</td>
                                            </tr>
                                            <tr>
                                                <td className="subscription-table-row-label">Cancel Anytime</td>
                                                <td><i className="fa-solid fa-check checkbox-subscription-table"></i></td>
                                                <td><i className="fa-solid fa-check checkbox-subscription-table"></i></td>
                                                <td><i className="fa-solid fa-check checkbox-subscription-table"></i></td>
                                            </tr>
                                            <tr>
                                                <td className="subscription-table-row-label">Best For</td>
                                                <td>New Users</td>
                                                <td>Short-Term Use</td>
                                                <td>Long-Term / Professional Users</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SubscriptionTable